import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import CheckMinus from 'src/javascripts/components/tables/checkboxes/CheckMinus';

// Show header with extra buttons/actions for checkboxes
export default function(tableId) {

  // Append a "check minus" template for user to hide header on click
  let selectDisplayedCheck = $('.dataTables_scrollHeadInner').find('.select-displayed-cells');
  let existingCheckMinus = $(selectDisplayedCheck).closest('th').find('.checkbox-minus');
  if (existingCheckMinus.length === 0) {
    $(selectDisplayedCheck).closest('th').append(CheckMinus());
  }

  // Re-set function to hide header row on click
  $('.checkbox-minus').click(function() {
    HideHeaderButtons(tableId);
  });

  // Show the header row
  let tr = $(selectDisplayedCheck).closest('tr');
  tr.addClass('bg-gray100');
  tr.find('th').addClass('bg-gray100');
  tr.find('th:not(:first-child)').css('opacity', 0);
  $('.hidden-header-buttons').removeClass('d-none').addClass('d-flex');

  // Set the number selected
  let numberChecked = $('#' + tableId).data('record-ids').length;
  let updatedPageLen = -1;
  let totalRecordsText = $('.totalRecords').text();
  let totalRecords = parseInt(totalRecordsText.replace(/,/g, ''), 10);
  $('#checkedCount').empty().append(numberChecked + ' selected');
  if (totalRecords > numberChecked) {
    $('#checkedCount').append(' <span class=\'small\' id=\'selectAllData\'>(<a class=\'clickable\'>select all ' + totalRecordsText + '</a>)</span>');
  }

  // On select all
  $('#selectAllData').click(function() {
    let totalRecordsText = $('.totalRecords').text();
    let totalRecords = parseInt(totalRecordsText.replace(/,/g, ''), 10);
    if (totalRecords > 250) {

      // Let user know the max selectable
      ToastCustom({
        title: 'Too many records', 
        message: 'You can select a maximum of 250 records at a time, try filtering down to fewer records', 
        delay: 8000, 
        autohide: true, 
        type: 'warning'
      });

    } else {
      $('#' + tableId).attr('data-preselect-all', 'true');
      $('#' + tableId).DataTable().page.len(updatedPageLen).draw();
      $('#checkedCount').empty().append('All records selected');      
    }

  });


}
